export default {
  'Animate old photos': 'Anima vecchie foto',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'Anima i volti nelle tue foto con la tecnologia AI, crea video vivaci.',
  'Upload a photo': 'Carica una foto',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    "Nota: assicurati che il viso nelle foto che hai selezionato sia rivolto verso l'obiettivo, altrimenti non può essere elaborato correttamente.",
  'Uploaded successfully!': 'Caricato con successo!',
  'Please select a template below': 'Seleziona un modello di seguito',
  'Choose a GIF': 'Scegli una GIF',
  'Use this template': 'Usa questo modello',
  'Verify successfully! You will':
    'Verifica con successo! A breve riceverai il video con {{email}}.',
  'You will': 'A breve riceverai il video con {{email}}.',
  'What you should expect to happen next':
    'Cosa dovresti aspettarti che accada dopo:',
  'We will process your photo into a dynamic video.':
    'Elaboreremo le tue foto in un video dinamico.',
  'After processing, we will send the video to your email.':
    "Dopo l'elaborazione, invieremo il video alla tua email.",
  'You can check the video in your email.':
    'Puoi controllare il video nella tua email.',
  'Your video will be delivered via email':
    'Il tuo video verrà consegnato tramite e-mail',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    "Occorrono 20-30 minuti per sintetizzare un video dinamico, sii paziente. Per proteggere la tua privacy, le immagini caricate verranno automaticamente eliminate al termine dell'elaborazione.",
  'Your Email': 'La tua email',
  'Last Name': 'Nome',
  'First Name': 'Cognome',
  'Go back': 'Torna indietro',
  'Invalid email address': 'Indirizzo di email non valido',
  'Enter verification code': 'Inserisci il codice di verifica',
  'Enter the verification code that we sent to':
    'Inserisci il codice di verifica che abbiamo inviato a {{email}}.',
  Resend: 'Manda di nuovo',
  'Verification code': 'Codice di verifica',
  'Resend after': 'Manda di nuovo dopo {{num}} secondi',
  'The verification code is invalid. You can request a new one.':
    'Il codice di verifica non è valido. Puoi richiederne uno nuovo.',
  'Synthesize Video': 'Sintetizza Video',
  Next: 'Al Prossimo',
  'Too many attempts, please try again later.':
    'Troppi tentativi, per favore riprova dopo.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
